// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutSettings_root__MhWeO","content":"LayoutSettings_content__3sZEO"};